import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { CREATE_ASSESSMENTS_REQUEST, FETCH_ASSESSMENTS_REQUEST } from "./constants";
import { Action, AssessmentItems } from "./types";

function items(state: AssessmentItems = [], action: Action): AssessmentItems {
  switch (action.type) {
    case getSuccessActionType(FETCH_ASSESSMENTS_REQUEST):
      return action.payload;
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_ASSESSMENTS_REQUEST:
    case CREATE_ASSESSMENTS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_ASSESSMENTS_REQUEST):
    case getFailureActionType(FETCH_ASSESSMENTS_REQUEST):
    case getSuccessActionType(CREATE_ASSESSMENTS_REQUEST):
    case getFailureActionType(CREATE_ASSESSMENTS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const assessments = combineReducers({ items, isFetching });
